import styles from './Home.module.scss';
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import MainPage from '../MainPage/MainPage';
import Cards from '../Cards/Cards';
import Values from '../Values/Values';
import Carousel from '../Carousel/Carousel';
import MailForm from '../MailForm/MailForm';
import copy from 'copy-to-clipboard';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Home = (props) => {

  useEffect(() => {
    AOS.init({duration: 1000});
  }, []);

  // copy to clipboard

  const handleCopyToClipboard = (text) => {
    copy(text);
    // alert('Skopiowano do schowka: ' + text);

    toast.dismiss();

    toast.success(`Skopiowano do schowka:\n${text}`, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 1000, // Czas wyświetlania w milisekundach (tutaj 2 sekundy)
    });
  };

  return (
    <div className={styles.dd}>
      <div className={styles.servicesBack} style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/bakii.png'})`}}>
        <MainPage scrollToSection={props.scrollToSection} language={props.language} />

        <div className={styles.phoneTab}>
          <div className={styles.hoverLinePhone}>
            <div className={styles.hoverInnerPhone} >
              <p className={styles.number} onClick={e => {handleCopyToClipboard('+48 690 688 835')}}>
                &nbsp;&nbsp; +48 <strong>690 688 835 </strong>
              </p>
              <div className={styles.imgPhotoDiv}>
                <img className={styles.imgPhoto} alt="phone" src={`${process.env.PUBLIC_URL}/tel.png`}></img>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.emailTab}>
          <div className={styles.hoverLineEmail}>
            <div className={styles.hoverInnerEmail}>
              <p className={styles.email} onClick={e => {handleCopyToClipboard('cometweb.kontakt@gmail.com')}}>
                &nbsp;&nbsp;cometweb.kontakt@gmail.com
              </p>
              <div className={styles.imgEmailDiv}>
                <img className={styles.imgEmail} alt="email" src={`${process.env.PUBLIC_URL}/emailicon.png`}></img>
              </div>
            </div>
          </div>
        </div>

        
        <div className={styles.facebookTab}>
          <div className={styles.hoverLineFacebook}>
            <div className={styles.hoverInnerFacebook}>
              <p className={styles.facebook} onClick={e => {handleCopyToClipboard('fb.com/cometwebFB')}}>
                &nbsp;&nbsp;fb.com/cometwebFB
              </p>
              <div className={styles.imgPhotoDiv}>
                <img className={styles.imgPhoto} alt="facebook" src={`${process.env.PUBLIC_URL}/facebookicon.png`}></img>
              </div>
            </div>
          </div>
        </div>
    
      <div className={styles.gapAfterMain}></div>

      <span className={styles.servicesWrapper}>
        <div className={styles.sevicesSection} ref={props.scrollRefs.sesja1}>
          <div className={styles.link} to="/tworzeniestroniaplikacjiinternetowych">
            <div className={styles.servicesCardLeft}>
              <div className={styles.desc}>
                <div className={styles.title}>
                  {props.language === 'pl' &&
                    <h1 data-aos="fade-down">
                        Strony internetowe
                    </h1>
                  }
                  {props.language === 'eng' &&
                    <h1 data-aos="fade-down">
                        Websites
                    </h1>
                  }
                </div>
                <div className={styles.linesCenter} data-aos="fade-right">
                  <div className={styles.FirstLine}></div>
                  <div className={styles.SecondLine}></div>
                  <div className={styles.ThirdLine}></div>
                </div>
                {props.language === 'pl' &&
                  <p>
                    Projektujemy responsywne strony internetowe, zapewniające wiarygodność i profesjonalizm Twojej
                    działalności co wpłynie na jej rozwój i zwiekszenie zysków. W dzisiejszych czasach obecność w internecie jest 
                    niezbędna do dotarcia do najszerszego grona odbiorców 
                    oraz zapewnienia łatwej i efektywnej komunikacji oraz współpracy z klientem.
                  </p>
                }
                {props.language === 'eng' &&
                  <p>
                    We design responsive websites, providing credibility and professionalism to your
                    business which will affect its development and increase profits. Nowadays, presence on the Internet is 
                    essential to reach the widest audience 
                    and ensure easy and effective communication and cooperation with the client.
                  </p>
                }
              </div>

              <div className={styles.gapBetween}></div>

              <div className={styles.imgDiv}>
                <img className={styles.img} alt="homewebdesign" src={`${process.env.PUBLIC_URL}/homewebdesign.jpg`}></img>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.interlude}>
          <div className={styles.interludeFilling}></div>
        </div>

        <div className={styles.sevicesSection} ref={props.scrollRefs.sesja2}>
          <div className={styles.link} to="/socialmediamarketing">
            <div className={styles.servicesCardLeft}>

              <div className={styles.imgDiv}>
                <img className={styles.img} alt="homesmm" src={`${process.env.PUBLIC_URL}/appweb.jpg`}></img>
              </div>

              <div className={styles.gapBetween}></div>

              <div className={styles.desc}>
                <div className={styles.title}>
                  {props.language === 'pl' &&
                    <h1 data-aos="fade-down">
                        Aplikacje webowe &nbsp;
                    </h1>
                  }
                  {props.language === 'eng' &&
                    <h1 data-aos="fade-down">
                        Web applications &nbsp;
                    </h1>
                  }
                </div>
                <div className={styles.linesCenter} data-aos="fade-left">
                  <div className={styles.FirstLine}></div>
                  <div className={styles.SecondLine}></div>
                  <div className={styles.ThirdLine}></div>
                </div>
                {props.language === 'pl' &&
                  <p>
                    W dzisiejszym dynamicznym środowisku biznesowym, posiadanie aplikacji webowych jest kluczowe dla efektywnej komunikacji i 
                    współpracy z klientami, a także dotarcia do szerokiego grona odbiorców. Wasze aplikacje webowe są zaprojektowane w taki sposób, 
                    aby zapewnić wiarygodność i profesjonalizm Twojej działalności. 
                    Dzięki nim, Twoi klienci będą mogli korzystać z zaawansowanych funkcji i usług dostępnych online.
                  </p>
                }
                {props.language === 'eng' &&
                  <p>
                    In today's dynamic business environment, having web applications is crucial for effective communication and 
                    collaboration with customers, as well as reaching a wide audience. Your web applications are designed in such a way, 
                    to provide credibility and professionalism to your business. 
                    With them, your customers will be able to take advantage of the advanced features and services available online.
                  </p>
                }
              </div>
            </div>
          </div>
        </div>

        <div className={styles.interlude}>
          <div className={styles.interludeFilling}></div>
        </div>

        <div className={styles.sevicesSection} ref={props.scrollRefs.sesja3}>
          <div className={styles.link} to="/vulnerabilitytesty">
            <div className={styles.servicesCardLeft}>
              <div className={styles.desc}>
                <div className={styles.title}>
                  {props.language === 'pl' &&
                    <h1 data-aos="fade-down">
                      Vulnerability testy
                    </h1>
                  }
                  {props.language === 'eng' &&
                    <h1 data-aos="fade-down">
                      Vulnerability tests
                    </h1>
                  }
                </div>
                <div className={styles.linesCenter} data-aos="fade-right">
                  <div className={styles.FirstLine}></div>
                  <div className={styles.SecondLine}></div>
                  <div className={styles.ThirdLine}></div>
                </div>
                {props.language === 'pl' &&
                  <p>
                    Testy vulnerability to szczegółowa i profesjonalna analiza bezpieczeństwa Twojej strony internetowej, 
                    która pozwala na zidentyfikowanie potencjalnych luk bezpieczeństwa. 
                    Nasze testy opierają się na najnowszych metodach i narzędziach branżowych, 
                    aby zapewnić najbardziej kompleksowe i dokładne wyniki.
                  </p>
                }
                {props.language === 'eng' &&
                  <p>
                    Vulnerability testing is a detailed and professional security analysis of your website, 
                    which allows you to identify potential security vulnerabilities. 
                    Our tests are based on the latest industry methods and tools, 
                    to provide the most comprehensive and accurate results.
                  </p>
                }
              </div>

              <div className={styles.gapBetween}></div>

              <div className={styles.imgDiv}>
                <img className={styles.img} alt="homecybersec" src={`${process.env.PUBLIC_URL}/homecybersec.jpg`}></img>
              </div>
            </div>
          </div>
        </div>
      </span>
      {/* </div> */}

      <div className={styles.justDiv}></div>

    </div>

      <div className={styles.contactUsSection} 
        style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/wycena.jpg'})`}}>
        <div className={styles.buttonContactLink} to="/contact">
          {props.language === 'pl' &&
            <button className={styles.buttonContact} onClick={() => props.scrollToSection('sesja4')}>
              <div>&nbsp;&nbsp; Skontaktuj się z nami po darmową wycenę &nbsp;&nbsp;</div>
            </button>
          }
          {props.language === 'eng' &&
            <button className={styles.buttonContact} onClick={() => props.scrollToSection('sesja4')}>
              <div>&nbsp;&nbsp; Contact us for a free pricing &nbsp;&nbsp;</div>
            </button>
          }
        </div>
      </div>

      <div className={styles.whoAreWeBackground}
        style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/light.png'})`}}>
        <div className={styles.whoAreWeSection}>
          {props.language === 'pl' &&
            <h1 data-aos="fade-down">Czym się zajmujemy?</h1>
          }
          {props.language === 'eng' &&
            <h1 data-aos="fade-down">What do we do?</h1>
          }
          <div className={styles.lines} data-aos="fade-left">
            <div className={styles.FirstLine}></div>
            <div className={styles.SecondLine}></div>
            <div className={styles.ThirdLine}></div>
          </div>
          {props.language === 'pl' &&
            <p className={styles.whoAreWeDesc}>
              W Cometweb rozumiemy jak ważna jest silna obecność w sieci w dzisiejszym cyfrowym świecie, 
              dlatego też ściśle współpracujemy z naszymi klientami, aby zrozumieć ich cele i wizje, a następnie przełożyć 
              je na stronę internetową, która dokładnie reprezentuje ich markę oraz napędza wyniki.
              Wykorzystujemy najnowsze technologie i trendy w projektowaniu, aby tworzyć strony internetowe, które są nie 
              tylko atrakcyjne wizualnie, ale również funkcjonalne i przyjazne dla użytkownika.
            </p>
          }
          {props.language === 'eng' &&
            <p className={styles.whoAreWeDesc}>
              At Cometweb, we understand the importance of having a strong online presence in today's digital world, 
              which is why we work closely with our clients to understand their goals and visions, and then translate 
              them into a website that accurately represents their brand and drives results.
              We use the latest technologies and design trends to create websites that are not 
              not only visually appealing, but also functional and user-friendly.
            </p>
          }

          <div className={styles.lineGap}></div>

          {props.language === 'pl' &&
            <p className={styles.whoAreWeDesc}>
              Niezależnie od tego, czy chcesz uruchomić nową stronę internetową, odświeżyć istniejącą, czy poprawić swoją 
              strategię marketingową online, posiadamy wiedzę i doświadczenie, które pomogą Ci zwiększyć zyski i odnieść sukces.
            </p>
          }
          {props.language === 'eng' &&
            <p className={styles.whoAreWeDesc}>
              Whether you want to launch a new website, refresh your existing one, or improve your 
              online marketing strategy, we have the expertise and experience to help you increase profits and succeed.
            </p>
          }
        </div>

        <div className={styles.howWeWorkSectionLabel}>
          <div className={styles.howWeWorkTopLabel}>
            {props.language === 'pl' &&
              <h1 data-aos="fade-down">Jak pracujemy?</h1>
            }
            {props.language === 'eng' &&
              <h1 data-aos="fade-down">How do we work?</h1>
            }
            <div className={styles.lines} data-aos="fade-left">
              <div className={styles.FirstLine}></div>
              <div className={styles.SecondLine}></div>
              <div className={styles.ThirdLine}></div>
            </div>
          </div>
        </div>

        <div className={styles.howWeWorkSection}>
          <div className={styles.stepsDiv}>
            <div className={styles.steps}>
              <div className={styles.singleStep}>
                <div className={styles.stepTitleDiv}>
                  {props.language === 'pl' &&
                    <Cards title='Wymagania i wycena' cardImgId='icon1'
                      desc='Najpierw, musimy zrozumieć Twój projekt, aby móc spełnić Twoje oczekiwania.
                        Przygotujemy dokładną wycenę i oszacujemy potrzebny czas na realizację.'
                    />
                  }
                  {props.language === 'eng' &&
                    <Cards title='Requirements and pricing' cardImgId='icon1'
                      desc='First, we need to understand your project so we can meet your expectations.
                        We will prepare an accurate quote and estimate the time needed for implementation.'
                    />
                  }
                </div>

                <div className={styles.leftBar}>
                  <div className={styles.stepEmpty}></div>
                  <div className={styles.dotLeft}>
                    <div className={styles.innerDot}></div>
                  </div>
                  <div className={styles.stepProgressBarLeft}></div>
                </div>
              </div>

              <div className={styles.singleStep}>
                <div className={styles.stepTitleDiv}>
                  {props.language === 'pl' &&
                    <Cards title='Planowanie i projektowanie' cardImgId='icon2'
                      desc='Zaplanujemy naszą pracę, zidentyfikujemy możliwe wyzwania i upewnimy się, 
                        że możliwe jest spełnienie wszystkich wymagań.
                        Zaprojektujemy Twoją aplikację i przygotujemy architekturę systemu.'
                    />
                  }
                  {props.language === 'eng' &&
                    <Cards title='Planning and design' cardImgId='icon2'
                      desc='We will plan our work, identify possible challenges and make sure, 
                        that it is possible to meet all requirements.
                        We will design your application and prepare the system architecture.'
                    />
                  }
                </div>

                <div className={styles.stepProgressBarFull}>
                  <div className={styles.dot}>
                    <div className={styles.innerDot}></div>
                  </div>
                </div>
              </div>
            
              <div className={styles.singleStep}>
                <div className={styles.stepTitleDiv}>
                  {props.language === 'pl' &&
                    <Cards title='Kodowanie i testowanie' cardImgId='icon3'
                      desc='Powołamy do życia Twoją aplikację, tworząc front-end i back-end.
                        Zadbamy o jej bezpieczeństwo oraz upewnimy się, że aplikacja działa zgodnie z założeniami.'
                    />
                  }
                  {props.language === 'eng' &&
                    <Cards title='Coding and testing' cardImgId='icon3'
                      desc='We will bring your application to life, creating the front-end and back-end.
                      We will take care of its security and make sure that the application works as intended.'
                    />
                  }
                </div>

                <div className={styles.stepProgressBarFull}>
                  <div className={styles.dot}>
                    <div className={styles.innerDot}></div>
                  </div>
                </div>
              </div>

              <div className={styles.singleStep}>
                <div className={styles.stepTitleDiv}>
                  {props.language === 'pl' &&
                    <Cards className={styles.gh} title='Wdrożenie i utrzymanie' cardImgId='icon4'
                      desc='Kiedy Twoja aplikacja będzie gotowa, zostanie uruchomiona i będzie utrzymywana. 
                        Jeśli będzie to planowane, opracujemy dodatkowe funkcje.'
                    />
                  }
                  {props.language === 'eng' &&
                    <Cards className={styles.gh} title='Implementation and &nbsp;&nbsp; maintenance' cardImgId='icon4'
                      desc='When your application is ready, it will be launched and maintained. 
                        If planned, we will develop additional features.'
                    />
                  }
                </div>

                <div className={styles.leftBar}>
                  <div className={styles.stepProgressBarLeft}></div>
                  <div className={styles.dotLeft}>
                    <div className={styles.innerDot}></div>
                  </div>
                  <div className={styles.stepEmpty}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Values /> */}

        <MailForm scrollRefs={props.scrollRefs} language={props.language} /> 

        <Carousel language={props.language} />

      </div>
    </div>
  );
};

export default Home;